<mat-nav-list class="!p-0">
  @for (action of data.actions; track $index) {
    <div
      mat-list-item
      (click)="fireAction(action)"
      class="flex flex-row items-center justify-between gap-2 py-2 rounded-full badge-primary badge-no-text sia-hover"
      [matBadge]="1"
      [matBadgeHidden]="!action.showBadge"
      matBadgeSize="medium"
      matBadgePosition="before"
    >
      <div class="flex flex-row items-center gap-2">
        <mat-icon> {{ action.icon }}</mat-icon>
        {{ action.name | siaTranslate }}
      </div>
      @if (action.actionType == 'group' || action.style == 'list') {
        <mat-icon>chevron_right</mat-icon>
      }
    </div>
  }
  <div
    mat-list-item
    class="flex justify-center pt-6 pb-4"
    (click)="closeBottomSheet()"
  >
    <button mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-nav-list>
